// extracted by mini-css-extract-plugin
export default {"root":"Pn0g6"};